import { c as _c } from "react/compiler-runtime";
// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================
import { useQueryClient } from '@tanstack/react-query';
import { notificationsKeys } from '../queries/keys';
export const useInvalidateNotificationUnreadCounts = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = () => queryClient.invalidateQueries({
      queryKey: notificationsKeys.notificationUnreadCounts()
    });
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};